<mat-expansion-panel class="pc-schedule-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span class="pc-schedule-status" [class.pc-schedule-status--active]="notification.enabled"></span>
      <span class="pc-schedule-name">{{ notification.name || 'Untitled notification' }}</span>
    </mat-panel-title>
    <mat-panel-description>{{ getTitle(notification) }}</mat-panel-description>
  </mat-expansion-panel-header>

  <div class="pc-panel-content">
    <div class="pc-panel-topline">
      <mat-form-field appearance="outline">
        <mat-label>Notification name</mat-label>
        <input matInput [(ngModel)]="notification.name">
      </mat-form-field>

      <div class="pc-panel-topline__actions">
        <mat-slide-toggle [(ngModel)]="notification.enabled">{{ notification.enabled ? 'Enabled' : 'Disabled' }}</mat-slide-toggle>
        <button mat-stroked-button class="pc-delete-button" (click)="delete()">
          <mat-icon>delete_outline</mat-icon>
          Remove
        </button>
      </div>
    </div>

    <div class="pc-form-section">
      <div class="pc-form-section__heading">
        <mat-icon>schedule</mat-icon>
        <div>
          <h4>Delivery schedule</h4>
          <p>Choose when this summary should be sent.</p>
        </div>
      </div>

      <div class="pc-schedule-grid">
        <mat-form-field appearance="outline">
          <mat-label>Frequency</mat-label>
          <mat-select [(ngModel)]="notification.frequency" (selectionChange)="frequencyChange($event, notification)">
            @for (f of frequencies; track f.key) {
              <mat-option [value]="f.key">{{f.display}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (notification.frequency == 'weekly') {
          <mat-form-field appearance="outline">
            <mat-label>Day of week</mat-label>
            <mat-select [(ngModel)]="notification.dayOfWeek">
              @for (d of daysOfWeek; track d.key) {
                <mat-option [value]="d.key">{{d.display}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (notification.frequency == 'monthly') {
          <mat-form-field appearance="outline">
            <mat-label>Day of month</mat-label>
            <mat-select [(ngModel)]="notification.dayOfMonth">
              @for (d of daysOfMonth; track d.key) {
                <mat-option [value]="d.key">{{d.display}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field appearance="outline">
          <mat-label>Time</mat-label>
          <mat-select [(ngModel)]="notification.hour">
            @for (h of hours; track h.key) {
              <mat-option [value]="h.key">{{h.display}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>AM / PM</mat-label>
          <mat-select [(ngModel)]="notification.ampm">
            <mat-option value="am">AM</mat-option>
            <mat-option value="pm">PM</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="pc-form-section">
      <div class="pc-form-section__heading">
        <mat-icon>group</mat-icon>
        <div>
          <h4>Recipients and content</h4>
          <p>Select the roles and task filters included in the summary.</p>
        </div>
      </div>

      <div class="pc-recipient-grid">
        <mat-form-field appearance="outline">
          <mat-label>Roles</mat-label>
          <mat-select [(ngModel)]="selectedRoles" multiple>
            <mat-select-trigger>
              {{selectedRoles.length == roles.length ? 'All roles' : ''}}
              {{selectedRoles.length != roles.length && selectedRoles.length > 0 ? selectedRoles[0].name : ''}}
              @if (selectedRoles.length != roles.length && selectedRoles?.length > 1) {
                <span class="pc-additional-selection">
                  (+{{selectedRoles.length - 1}} {{selectedRoles?.length === 2 ? 'other' : 'others'}})
                </span>
              }
            </mat-select-trigger>
            @for (role of roles; track role.id) {
              <mat-option [value]="role">{{role.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="pc-filter-options">
          <mat-checkbox [(ngModel)]="assigned">Only tasks assigned to the recipient</mat-checkbox>
          <mat-checkbox [(ngModel)]="incomplete">Exclude completed tasks</mat-checkbox>
        </div>
      </div>

      <div class="pc-preview">
        <mat-icon>preview</mat-icon>
        <div>
          <span>Example notification</span>
          <strong>{{token.example}}</strong>
        </div>
      </div>
    </div>
  </div>
</mat-expansion-panel>
